var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Package"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.95 10.3349L21.2 2.81143C20.8326 2.60843 20.4197 2.50195 20 2.50195C19.5803 2.50195 19.1674 2.60843 18.8 2.81143L5.05 10.338C4.65733 10.5528 4.32954 10.8692 4.10086 11.254C3.87219 11.6388 3.75102 12.0779 3.75 12.5255V27.4692C3.75102 27.9169 3.87219 28.356 4.10086 28.7408C4.32954 29.1256 4.65733 29.4419 5.05 29.6567L18.8 37.1833C19.1674 37.3863 19.5803 37.4928 20 37.4928C20.4197 37.4928 20.8326 37.3863 21.2 37.1833L34.95 29.6567C35.3427 29.4419 35.6705 29.1256 35.8991 28.7408C36.1278 28.356 36.249 27.9169 36.25 27.4692V12.5271C36.2498 12.0786 36.129 11.6385 35.9003 11.2529C35.6716 10.8672 35.3434 10.5501 34.95 10.3349ZM20 4.99893L32.5531 11.8739L27.9016 14.4208L15.3469 7.5458L20 4.99893ZM20 18.7489L7.44688 11.8739L12.7437 8.97393L25.2969 15.8489L20 18.7489ZM6.25 14.0614L18.75 20.9021V34.3067L6.25 27.4708V14.0614ZM33.75 27.4646L21.25 34.3067V20.9083L26.25 18.1724V23.7489C26.25 24.0805 26.3817 24.3984 26.6161 24.6328C26.8505 24.8672 27.1685 24.9989 27.5 24.9989C27.8315 24.9989 28.1495 24.8672 28.3839 24.6328C28.6183 24.3984 28.75 24.0805 28.75 23.7489V16.8036L33.75 14.0614V27.463V27.4646Z",
    fill: "#FF7A2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.c18966605e62b452cda1616dbf6b0856.svg";
export { ForwardRef as ReactComponent };